import PostRequest from 'components/common/PostRequest.jsx';

/**
 * Handles resetting the selected list for a nav section.
 * This is shared between QuoteBuilderNavSection and LayoutSvg components.
 *
 * @param {Object} options
 * @param {number} options.index - The nav section index
 * @param {Function} options.setSelectedList - State setter for selected list
 * @param {Function} [options.setSolution] - Optional state setter for solution (used in LayoutSvg)
 */
const resetSelectedListHandler = ({ index, setSelectedList, setSolution }) => {
  PostRequest({
    url: `/layouts-nav-section-combinations/reset-selected-list/${window.user_quote_id}/${index}`,
    data: {},
    callback: (data) => {
      setSelectedList(() => []);

      if (setSolution) {
        setSolution(() => undefined);
      }

      // Update window.user_quote_nav_sections so shouldHideSection can check updated data
      if (data.window_nav_sections) {
        window.user_quote_nav_sections = data.window_nav_sections;
      }

      // Emit event to reset linked sections and trigger re-render
      window.dispatchEvent(new CustomEvent('navSectionsReset', {
        detail: {
          resetIndices: data.reset_linked_indices || [],
          sourceIndex: index,
          windowNavSections: data.window_nav_sections
        }
      }));

      if (data.page_reload) {
        location.reload(true);
      }
    }
  });
};

export default resetSelectedListHandler;
